import { Directive, NgZone, Renderer2, ElementRef, AfterViewInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { dropHandlers, smoothDnD as SmoothDnDForTabItem, DropResult, ContainerOptions } from '@farris/smooth-dnd';

SmoothDnDForTabItem.dropHandler = dropHandlers.reactDropHandler().handler;
SmoothDnDForTabItem.wrapChild = false;

@Directive({
  selector: '[drag-tab]',
})
export class IdeDraggeTabDirective implements OnDestroy, AfterViewInit {
  private container: any;
  @Input('drag-tab') enableDrag = true;
  @Input() groupName = '';
  @Output() drop = new EventEmitter();

  @Input() options: ContainerOptions = {
    groupName: this.groupName,
    orientation: 'horizontal',
    behaviour: 'move',
    dragClass: 'drag-tab-moving--from-code-view',
    dropPlaceholder: {
      className: 'drop-group-field',
    },
    getGhostParent: () => {
      return document.body;
    },
    onDrop: (dropResult: DropResult) => {
      this.ngzone.run(() => {
        this.drop.emit(dropResult);
      });
    },
    onDragStart: (info: any) => {
      this.ngzone.run(() => {
        const activeTabPanel = document.querySelector('.app-iframe-panel--wrapper');
        if (activeTabPanel) {
          this.render.setStyle(activeTabPanel, 'pointer-events', 'none');
        }
      });
    },
    onDragEnd: () => {
      const activeTabPanel = document.querySelector('.app-iframe-panel--wrapper');
      if (activeTabPanel) {
        this.render.removeStyle(activeTabPanel, 'pointer-events');
      }
    }
  };

  constructor(
    private ngzone: NgZone,
    private render: Renderer2,
    private el: ElementRef
  ) { }

  ngAfterViewInit() {
    this.initDnD();
  }

  ngOnDestroy() {
    this.disposeDnd();
  }

  private disposeDnd() {
    if (this.container) {
      this.container.dispose();
      this.container = null;
    }
  }

  private initDnD() {
    this.options.groupName = this.groupName;
    this.disposeDnd();

    if (this.enableDrag) {
      this.container = SmoothDnDForTabItem(
        this.el.nativeElement,
        this.options
      );
    }
  }

}
